<template>
    <div class="relative items-center justify-between p-2 rounded-md bg-white shadow">
        <div class="flex py-1 items-center justify-between md:px-1">
            <div class="flex">
                <!--Mute Icon (Bullhorn)-->
                <svg v-if="!mutableChannel.user_settings.has_muted_channel" @click.prevent="muteChannel"
                     class="w-5 h-5 text-indigo-400 mr-1 cursor-pointer" viewBox="0 0 24 24">
                    <path fill="currentColor"
                          d="M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z"/>
                </svg>
                <svg v-else class="w-5 h-5 text-gray-400 mr-1 cursor-pointer" viewBox="0 0 24 24" @click.prevent="muteChannel">
                    <path fill="currentColor"
                          d="M3,9H7L12,4V20L7,15H3V9M16.59,12L14,9.41L15.41,8L18,10.59L20.59,8L22,9.41L19.41,12L22,14.59L20.59,16L18,13.41L15.41,16L14,14.59L16.59,12Z"/>
                </svg>

                <button @click.prevent="emitShowChannelEvent()" class="outline-none">
                    <span>
                        {{ mutableChannel.service_provider_team_name }}
                    </span>
                    <span v-if="type === 'inbox'">
                        &nbsp; &middot; &nbsp;
                        <span class="text-green-500 font-medium">
                            {{ mutableChannel.parent_model_details.asset_name }}
                        </span>
                        &nbsp; &middot; &nbsp;
                        <span class="text-gray-500">
                            {{ mutableChannel.parent_model_details.ticket_reference_number }}
                        </span>
                    </span>
                </button>
            </div>
            <!-- DESKTOP New Messages badge -->
            <div v-if="mutableChannel.number_of_unread_messages > 0"
                 class="hidden md:flex px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                {{ mutableChannel.number_of_unread_messages }} New {{ "Message" | pluralizeOnlyS(mutableChannel.number_of_unread_messages) }}
            </div>
        </div>

        <!-- MOBILE New Messages badge -->
        <span class="absolute flex md:hidden right-0 top-0 bg-red-100 text-red-800 rounded-tr rounded-bl px-2 text-sm"
              v-if="mutableChannel.number_of_unread_messages > 0">
            {{ mutableChannel.number_of_unread_messages }}</span>

        <div class="flex items-center px-4 py-2 cursor-pointer">
            <div class="p-3 rounded-md shadow-sm w-full bg-indigo-50" :class="type === 'inbox' ? 'bg-gray-100' : 'bg-gray-50'" @click.prevent="emitShowChannelEvent()">
                <div class="flex justify-between items-center text-indigo-600 font-medium mb-1 text-xs">
                    <div>{{ mutableChannel.last_message.relative_date }}</div>
                </div>
                <div>
                    <div class="text-xs text-gray-600">{{ mutableChannel.last_message.message }}</div>
                </div>
            </div>
            <!--Open Chat & Go to related model dashboard button-->
            <div v-if="type === 'inbox'" class="pt-2 pl-2">
                <el-tooltip content="Go to ticket" placement="bottom">
                    <a href="#" @click.prevent="openRelatedModelDashboard" class="px-2 text-gray-400 hover:text-blue-500">
                        <span class="h-5 w-5 inline-block">
                            <icon-chevron-right></icon-chevron-right>
                        </span>
                    </a>
                </el-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChannelListItem",
    props: {
        channel: {
            required: true,
            type: Object,
            default: null,
        },
        type: {
            required: true,
            type: String,
            description: "Inbox or Ticket"
        }
    },
    watch: {
        channel: {
            // We have to set deep to true here since the last message one a channel
            // can change in which case we want to trigger the ui to update the channel
            // to show the last message text in the list.
            deep: true,
            handler () {
                this.mutableChannel = this.channel;
            }
        }
    },
    data () {
        return {
            mutableChannel: this.channel
        };
    },
    methods: {
        muteChannel () {
            this.mutableChannel.user_settings.has_muted_channel = !this.mutableChannel.user_settings.has_muted_channel;
            axios.post("/messenger/channels/mute/" + this.mutableChannel.id)
            .then((response) => {
                toastr.success(response.data);
            })
            .catch((error) => {
                toastr.error("Unable to mute channel! " + error.message);
                this.mutableChannel.user_settings.has_muted_channel = !this.mutableChannel.user_settings.has_muted_channel;
            });
        },
        emitShowChannelEvent () {
            if (this.mutableChannel.user_list.includes(this.state.user.id)) {
                this.mutableChannel.number_of_unread_messages = 0;
            }
            this.$emit("show-channel", this.mutableChannel);
        },
        openRelatedModelDashboard () {
            switch (this.mutableChannel.model_type) {
                case "App\\Ticket":
                    window.open("/tickets/" + this.channel.model_id);
                    break;
            }
        },
    }

};
</script>

<style scoped>

</style>
